<template>
  <div class="step-aparencia">
    <div v-if="!slotHome" class="step-aparencia__vazio">
      <CIcon name="cil-info" size="lg" class="step-aparencia__vazio-icon" />
      <p>
        O local <strong>{{ local.label }}</strong> segue o layout padrão do site:
        não há largura nem aparência para ajustar.
      </p>
    </div>

    <template v-else>
      <div v-if="ehTexto" class="step-aparencia__preview">
        <PreviewBlocoTexto :item="item" />
      </div>

      <div class="section-label">Largura ocupada na linha</div>
      <CRow>
        <CCol md="4">
          <div class="form-group">
            <label class="field-label">
              <CIcon name="cil-screen-desktop" size="sm" class="mr-1" />
              Desktop
            </label>
            <select class="form-control form-control-sm" v-model="item.largura">
              <option v-for="largura in larguras" :key="`desktop-${largura.valor}`" :value="largura.valor">
                {{ largura.texto }}
              </option>
            </select>
            <div v-if="validacao.firstError('item.largura')" class="message">
              {{ validacao.firstError("item.largura") }}
            </div>
          </div>
        </CCol>
        <CCol md="4">
          <div class="form-group">
            <label class="field-label">Tablet</label>
            <select class="form-control form-control-sm" v-model="item.largura_tablet">
              <option :value="null">Automático (igual ao desktop)</option>
              <option v-for="largura in larguras" :key="`tablet-${largura.valor}`" :value="largura.valor">
                {{ largura.texto }}
              </option>
            </select>
          </div>
        </CCol>
        <CCol md="4">
          <div class="form-group">
            <label class="field-label">
              <CIcon name="cil-screen-smartphone" size="sm" class="mr-1" />
              Mobile
            </label>
            <select class="form-control form-control-sm" v-model="item.largura_mobile">
              <option :value="null">Automático</option>
              <option v-for="largura in larguras" :key="`mobile-${largura.valor}`" :value="largura.valor">
                {{ largura.texto }}
              </option>
            </select>
          </div>
        </CCol>
      </CRow>

      <template v-if="ehTexto">
        <div class="section-label">Fundo</div>
        <CRow>
          <CCol md="4">
            <div class="form-group">
              <label class="field-label">Tipo de fundo</label>
              <select class="form-control form-control-sm" v-model="item.estilo.fundo_tipo">
                <option value="nenhum">Nenhum (transparente)</option>
                <option value="solido">Cor sólida</option>
                <option value="gradiente">Gradiente (2 cores)</option>
              </select>
            </div>
          </CCol>
          <CCol v-if="item.estilo.fundo_tipo !== 'nenhum'" md="4">
            <div class="form-group">
              <label class="field-label">
                {{ item.estilo.fundo_tipo === "gradiente" ? "Cor inicial" : "Cor de fundo" }}
              </label>
              <ColorInput v-model="item.estilo.cor_fundo" />
            </div>
          </CCol>
          <CCol v-if="item.estilo.fundo_tipo === 'gradiente'" md="4">
            <div class="form-group">
              <label class="field-label">Cor final</label>
              <ColorInput v-model="item.estilo.cor_fundo_final" />
            </div>
          </CCol>
        </CRow>

        <div class="section-label">Texto</div>
        <CRow>
          <CCol md="4">
            <div class="form-group">
              <label class="field-label">Posição da imagem</label>
              <select class="form-control form-control-sm" v-model="item.estilo.posicao_imagem">
                <option value="fundo">Fundo (atrás do texto)</option>
                <option value="esquerda">Esquerda</option>
                <option value="direita">Direita</option>
                <option value="cima">Cima</option>
                <option value="baixo">Baixo</option>
              </select>
            </div>
          </CCol>
          <CCol md="4">
            <div class="form-group">
              <label class="field-label">Alinhamento</label>
              <select class="form-control form-control-sm" v-model="item.estilo.alinhamento_texto">
                <option value="esquerda">Esquerda</option>
                <option value="centro">Centro</option>
                <option value="direita">Direita</option>
              </select>
            </div>
          </CCol>
          <CCol md="4">
            <div class="form-group">
              <label class="field-label">Tamanho</label>
              <select class="form-control form-control-sm" v-model="item.estilo.tamanho_texto">
                <option value="pequeno">Pequeno (compacto)</option>
                <option value="medio">Médio (padrão)</option>
                <option value="grande">Grande (destaque)</option>
                <option value="gigante">Gigante (hero)</option>
              </select>
            </div>
          </CCol>
        </CRow>

        <div class="section-label">Botão de ação</div>
        <CRow>
          <CCol md="6">
            <div class="form-group">
              <label class="field-label">Texto do botão (opcional)</label>
              <input
                class="form-control form-control-sm"
                v-model="item.estilo.cta_texto"
                maxlength="80"
                placeholder="Ex.: Saiba mais (vazio = sem botão)"
              />
            </div>
          </CCol>
          <CCol md="3">
            <div class="form-group">
              <label class="field-label">Fundo do botão</label>
              <ColorInput v-model="item.estilo.cta_cor_fundo" />
            </div>
          </CCol>
          <CCol md="3">
            <div class="form-group">
              <label class="field-label">Texto do botão</label>
              <ColorInput v-model="item.estilo.cta_cor_texto" />
            </div>
          </CCol>
        </CRow>
      </template>

      <div class="section-label">Acabamento</div>
      <BooleanToggle
        label="Cantos arredondados"
        :value="item.estilo.cantos_arredondados"
        @input="(valor) => $set(item.estilo, 'cantos_arredondados', valor)"
      />
      <BooleanToggle
        label="Borda"
        :value="item.estilo.usa_borda"
        @input="(valor) => $set(item.estilo, 'usa_borda', valor)"
      />
      <CRow v-if="item.estilo.usa_borda" class="step-aparencia__borda">
        <CCol md="4">
          <div class="form-group">
            <label class="field-label">Cor da borda</label>
            <ColorInput v-model="item.estilo.cor_borda" />
          </div>
        </CCol>
        <CCol md="4">
          <div class="form-group">
            <label class="field-label">Espessura</label>
            <select class="form-control form-control-sm" v-model="item.estilo.espessura_borda">
              <option v-for="espessura in 6" :key="`espessura-${espessura}`" :value="espessura">
                {{ espessura }}px
              </option>
            </select>
          </div>
        </CCol>
      </CRow>
      <BooleanToggle
        label="Largura total da página"
        help="O conteúdo ignora a margem do site e ocupa toda a largura da tela"
        :value="item.estilo.largura_total"
        @input="(valor) => $set(item.estilo, 'largura_total', valor)"
      />

    </template>
  </div>
</template>

<script>
import BooleanToggle from "@/views/Campanhas/components/CampanhasComerciais/shared/BooleanToggle.vue";
import ColorInput from "@/components/ColorInput";
import PreviewBlocoTexto from "../shared/PreviewBlocoTexto.vue";
import { LARGURAS, getLocalConteudo } from "../helpers/conteudoLabels";
import { ehBlocoTexto, ehTipoSlotHome } from "../helpers/blocoConteudo";

export default {
  name: "StepAparencia",
  components: { BooleanToggle, ColorInput, PreviewBlocoTexto },
  props: {
    item: {
      type: Object,
      required: true,
    },
    validacao: {
      type: Object,
      required: true,
    },
    logosTipo: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      larguras: LARGURAS,
    };
  },
  computed: {
    slotHome() {
      return ehTipoSlotHome(this.item) && !!this.item.estilo;
    },
    ehTexto() {
      return ehBlocoTexto(this.item);
    },
    local() {
      return getLocalConteudo(this.item.chave, this.logosTipo);
    },
  },
};
</script>

<style scoped>
.field-label {
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
}

.message {
  font-size: 11px;
  color: #d92d20;
  margin-top: 2px;
}

.section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
  margin: 8px 0 6px;
}

.section-label:first-child {
  margin-top: 0;
}

.step-aparencia__borda {
  padding-left: 12px;
}

.step-aparencia__preview {
  position: sticky;
  top: 0;
  z-index: 2;
  margin-bottom: 12px;
  padding: 12px;
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  background: #f9fafb;
  box-shadow: 0 8px 16px -12px rgba(16, 24, 40, 0.45);
}

.step-aparencia__vazio {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 40px 20px;
  color: #667085;
}

.step-aparencia__vazio-icon {
  color: #98a2b3;
  margin-bottom: 8px;
}

.step-aparencia__vazio p {
  font-size: 13px;
  margin: 0;
  max-width: 420px;
}
</style>
